<template>
  <div v-show="showModal" class="rich-modal">
    <div @click.stop="" class="modal-container">
      <div @click="close" class="close-img"></div>
      <div v-if="showBackBtn" @click="back" class="back-img"></div>
      <div class="title">{{ title }}</div>
      <div class="main-container">
        <slot></slot>
      </div>
      <div class="bottom-btn" @click="btnClick">{{ buttonText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RichModalComponent",
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    // 是否显示已做v-model
    show: {
      type: Boolean,
      default: true,
    },
    title: {
      // 标题栏
      type: String,
      default: "",
    },
    buttonText: {
      // 按钮文案
      type: String,
      default: "",
    },
    showBackBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.show,
    };
  },
  methods: {
    /**
     * 打开instagram
     */
    btnClick() {
      this.$emit("btn-click");
    },
    /**
     * 关闭按钮点击事件
     */
    close() {
      this.$emit("close");
    },
    /**
     * 返回按钮点击事件
     */
    back() {
      this.$emit("back");
    },
  },
  watch: {
    showModal(val) {
      this.$emit("updateShow", val);
    },
    show(val) {
      this.showModal = val;
    },
  },
};
</script>

<style scoped lang="less">
@theme-color: #e20034;
// ios设备整体向上移动
&.ios-platform {
  position: relative;
  bottom: 50px;
}
.rich-modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 110vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 501;

  .modal-container {
    max-width: 85vw;
    width: 550px;
    background: white;
    border-radius: 10px;
    padding: 20px 25px 0 25px;
    position: relative;
    bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .close-img {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 10px;
      right: 10px;
      background-image: url("../../../../public/images/login/close1.png");
      background-position: center;
      background-size: contain;
      cursor: pointer;
    }

    .back-img {
      width: 23px;
      height: 23px;
      position: absolute;
      top: 10px;
      left: 10px;
      background-image: url("../../../../public/images/login/back.png");
      background-position: center;
      background-size: contain;
      cursor: pointer;
    }

    .title {
      font-size: 18px;
      font-weight: 600;
    }

    .main-container {
      width: 100%;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      overflow-x: hidden;
    }

    .bottom-btn {
      max-width: 85vw;
      width: 550px;
      height: 44px;
      background: @theme-color;
      color: white;
      font-size: 18px;
      border-radius: 0 0 10px 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      cursor: pointer;
      &:active {
        opacity: 0.7;
      }
    }
  }
}
</style>
